'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var config = require('./config');

/**
 * Create Component Exports
 */
function create(name, component) {
    var options = component.options || component;
    options.name = config.prefix + name;
    options.install = function (Vue) {
        Vue.component(options.name, options);
    };
    options.registration = (_a = {}, _a[options.name] = options, _a);
    return options;
    var _a;
}

exports.create = create;
